var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"color":"primary"},model:{value:(_vm.saved),callback:function ($$v) {_vm.saved=$$v},expression:"saved"}},[_vm._v(_vm._s(_vm.$t("messages.saved")))])}
var staticRenderFns = []

export { render, staticRenderFns }